<template>	
	<div>
			<div class="mfty-box">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Maob-SCADA数据采集监控系统
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row" style="justify-content: space-between;">
						<img src="../../assets/img/scadaImg.png" />
						<div class="col" style="margin-left: 25px;justify-content: flex-start;">
							
							<div class="item-no" style="font-size: 16px;color: #696969;line-height: 29px;text-align: left;margin-top: -5px;">
								SCADA（Supervisory Control And Data Acquisition）系统是"制造业物联网信息总线"的具体实现，它包含两个层次的含义：一是分步式的实时数据采集系统，即工业通讯与控制的PC上位机系统 ；另一个是生产现场的场景建模和显示系统。
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;margin-top: 30px;line-height: 29px;text-align: left;">
								SCADA采用OPC/ModBUS/SECS等工业协议来连接工厂中的各种智能控制设备等。这些智能采集设备与生产过程和事务管理的设备或仪表相结合，时感知设备各种参数的状态，并将这些状态信号转换成数字信号，并通过特定数字通信网络传递到设备PLC中。必要的时候，SCADA也可以向设备发送控制信号。SCADA在接受设备的反馈信息后，以适当的形式如声音、图形、图象等方式显示给用户，以达到监视的目的。数据经过处理后，告知用户设备各种参数的状态（报警、正常或报警恢复），这些处理后的数据可能会甄别之后保存到MES制造执行系统的数据库中，也可以通过网络系统传输到不同的监控平台上。
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			<div class="gywm-box" >
				<div class="row ju-c al-c" style="color: #fff;font-size: 32px;font-weight: bold;">
					Maob-SCADA技术特性
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row">
						<div class="col" style="align-items: flex-start;">
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 可视化场景组态建模
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 基于Microsoft .Net和WPF技术
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 内嵌C#.Net和Javascript脚本引擎
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 内置超过3000个图库
							</div>
						</div>
						<div class="col" style="align-items: flex-start;">
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 支持邮件，短信报警
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 支持Sqlite及SQLServer、ODBC数据库
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 支持定制启动画面和帮助信息
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 事件回放与趋势分析
							</div>
						</div>
						<div class="col" style="align-items: flex-start;">
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 15px;letter-spacing: 0px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 支持OPC/ModBUS/SECS-GEM/RS232/Socket协议
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 支持32位和64位Windows系统
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 内置微型OPC服务器，支持XML数据交换
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 与Mabao-MES系统彻底融合
							</div>
						</div>
					</div>
					
				</div>
			</div>
			
			<div class="mfty-box" style="height: 750px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Maob-SCADA系统特点优势
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;position: relative;">
					<div style="background-color: #fff;width: 70px;top: 220px;left: 565px;height: 70px;border-radius: 50%;position: absolute;"></div>
					<div class="row" style="justify-content: space-between;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #0bcdcd;padding: 40px 50px;">
							 <div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								 过程工艺参数及设备状态参数监控
							 </div>
							 <div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
							 	图形化展示工厂的生产工艺过程，并将机台指标进行挂钩及实时展示。界面绘制考虑整体工艺流程，数据点与界面进行紧密关联，界面采用模块化设计，便于用户视觉角度的体验。整体界面加入了设备形象化处理元素，达到看图便知的作用。
							 </div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #20d29f;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								实时数据分析、归档、趋势展示
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								系统对各个数据点进行历史记录，记录频次达到秒级。对于关注的工艺指标，可以指定任意时间段去检索数据，并形成数据表格及曲线走势，帮助用户更好的分析指标的稳定性和是否存在异常；历史数据点与机台进行了紧密关联。
							</div>
						</div>
					</div>
					<div class="row" style="justify-content: space-between;margin-top: 30px;">
						<div class="col-no" style="width: 585px;height: 240px;background-color: #ff9852;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								报警、预警
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								实时监控工艺流程过程中各个指标是否符合工艺要求，对于不符合工艺范围的指标给予及时报警，并与界面通过颜色重点突出醒目；加入了异常信息记录的保存功能，可以查询某一时间段内指标的异常汇总情况。
							</div>
						</div>
						<div class="col-no" style="width: 585px;height: 240px;background-color: #6f7af5;padding: 40px 50px;">
							<div class="item-no" style="font-size: 24px;font-weight: bold;color: #fff;">
								中心数据服务处理强
							</div>
							<div class="item-no" style="color: #fff;margin-top: 30px;line-height: 26px;text-align: left;font-size: 16px;">
								数据处理后直接放入Oracle / MS SQL Server等规范数据库中，方便用户进行数据开掘，分析处理同时方便供给二次开发，为用户完成各种功能。
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				curHeight: 0,
				index: 1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>

	.gywm-box{
		height: 800px;
		background-image: url(../../assets/img/SCADAbg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding-top: 80px;
		text-align: center;
	}
	.center-body {
		margin: 0 auto;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}

	.centerbtn {
		width: 240px;
		border-radius: 25px;
		background-color: #ff7e00;
		height: 50px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.com {
		font-size: 18px;
		color: #aaaaaa;
	}

	.active {
		color: #0070FD;
	}
</style>
